import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { chatList, insertChat } from 'modules/actions/chat';
import IconButton from 'components/atoms/Button/IconButton';
import axios from 'axios';

const SearchJichung = () => {
  const dispatch = useDispatch();
  const sido_ref = useRef();
  const sigungu_ref = useRef();
  const sidoList = useSelector(state => state.searchAddr.sido);
  const [sigunguSelectOptions, setSigunguSelectOptions] = useState([]);
  const [sigunguIsDisabled, setSigunguIsDisabled] = useState(false);
  const [state, setState] = useState(false);
  
  const closeModal = () => {
    dispatch(disableAllMenu());
  };

  const fetchSidoOptions = async () => {
    if(sido_ref.current.value === "세종특별자치시"){
      setSigunguIsDisabled(true);
      setState(true); // 세종특별자치시 경우에는 시/도만 선택해도 검색 가능
      sigungu_ref.current.value = "";
    }else{
      // 시군구 초기화
      setSigunguSelectOptions([]);
      setSigunguIsDisabled(false);
      setState(false);
      sigungu_ref.current.value = "";

      // 시도 선택 안 할 시
      if (!sido_ref.current.value) return false;

      // 선택영역 value 가져오기
      const sido_value = sido_ref.current.value;
  
      // 주소 api
      await axios.post('/chat/addressAggs', {
        index: 'jichung',
        sido: sido_value,
      }).then(response => {
        setSigunguSelectOptions(response.data.aggs);
      }).catch(error => {
        console.log(error);
      })
    }
  }

  const fetchSigunguOptions = () => {
    if(sido_ref.current.value && sigungu_ref.current.value){
      setState(true);
    }
  };

  const confirmEvt = async () => {
    if (!state) return false;
    const sido_value = sido_ref.current.value;
    const sigungu_value = sigungu_ref.current.value;
    const loginYN = sessionStorage.getItem('mbrId') ? 'true' : 'false';
    const setParam = {
      user_id: sessionStorage.getItem('user_id'),
      inType: 'query',
      inStr: sido_value + ' ' + sigungu_value + ' 관할 보훈(지)청',
      session_id: sessionStorage.getItem('session_id'),
      channel_id: sessionStorage.getItem('device'),
      parameters: { check_btn:'Y', mbr_id: sessionStorage.getItem('mbrId'), login: loginYN, sido: sido_value, sigungu : sigungu_value }
    };
    dispatch(chatList(setParam));
    dispatch(disableAllMenu());
  };

  return (
    <div className="jichung_bg">
      <div className="jichung_area" >
        <button type="button" aria-label="닫기" title="관할 보훈(지)청 찾기 창 닫기" className="_close_btn_div" onClick={closeModal} >
          <i className="ri-close-line-2" />
        </button>
        <div className="fd_name fd_name_01">관할 보훈(지)청 찾기
          <p className="desc">지역을 선택하시면 관할 보훈(지)청 정보를 확인하실 수 있습니다.</p>
        </div>
        <div className='_input_div'>
          <div className="fd_btn_text">지역을 선택해주세요.  (주민등록상 주소 기준)</div>
          <ul className="_item">
            <li className="label">
              <div className="_tit"><label htmlFor="sido">시/도</label></div>
              <select className="select" name="sido" id="sido" ref={sido_ref} onChange={(e) => fetchSidoOptions()}>
                <option value="">시/도를 선택해주세요</option>
                {
                  sidoList?.map((data, index) => {
                    return (
                      <option key={index} value={data} >{data}</option>
                    )
                  })
                }
              </select>

            </li>
            <li className="label">
              <div className="_tit"><label htmlFor="sigungu">시/군/구</label></div>
              <select className="select" type="select" ref={sigungu_ref} name="sigungu" disabled={sigunguIsDisabled} id="sigungu" onChange={(e) => fetchSigunguOptions()}>
                <option value="">시/군/구를 선택해주세요.</option>
                {
                  sigunguSelectOptions?.map((data, index) => {
                    return (
                      <option key={index} value={data}>{data}</option>
                    )
                  })
                }
              </select>
            </li>
          </ul>
        </div>
        <button type="button" title="검색" className={`fd_send_btn ${state ? '' : '_inactive'}`} onClick={() => confirmEvt()}>
        {/* <button type="button" title="검색" className='fd_send_btn' onClick={() => confirmEvt()}> */}
          검색
        </button>
      </div>
    </div>
  );
};

export default SearchJichung;
